const activeNewsItemClass = 'active';

const cycleNewsItem = (list) => {
    const currentActiveItem = list.querySelector('li.active');
    const nextActiveItem = currentActiveItem.nextElementSibling;
    currentActiveItem.classList.remove(activeNewsItemClass);
    if (nextActiveItem) {
        nextActiveItem.classList.add(activeNewsItemClass);
    } else {
        list.querySelector('li').classList.add(activeNewsItemClass);
    }
};

const setupNewsCycle = (list, timePerItem) => {
    setInterval(() => {
        cycleNewsItem(list);
    }, timePerItem);
};

const newsTickerLists = document.querySelectorAll('.newsTickerList');
newsTickerLists.forEach((list) => {
    setupNewsCycle(list, 10000);
});
